import { ELEMENT_ATTRIBUTE_GROUP, ELEMENT_GROUPS } from './../utils';

const CalendarElementFields = {
  group: ELEMENT_GROUPS.OTHER,
  label: 'Calendar',
  icon: 'CalendarIcon',
  description: 'A calendar control',
  properties: [
    {
      label: 'Data Binding Source',
      name: 'datasourceId',
      description:
        'Choose a content type the calendar will populate dates from. Each document in the data source will be highlighted within the calendar dates.',
      editor: 'dropdown',
      function: {
        name: 'getDynamicDataSources',
        params: ['app.id']
      },
      default: '',
      displayWhen: [
        {
          field: 'databindingDisabled',
          operator: '!==',
          value: true
        }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Data Binding Field',
      name: 'sourceField',
      editor: 'dropdown',
      description:
        'The field from the underlying datasource that contains the dates to display on the calendar',
      default: '',
      options: [],
      function: {
        name: 'getDynamicDataSourceFields',
        values: [],
        params: ['app.id', 'element.datasourceId']
      },
      displayWhen: [
        {
          field: 'databindingDisabled',
          operator: '!==',
          value: true
        }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Hide Data Source Entries',
      name: 'hideDataSourceEntries',
      description:
        'If true, will not show documents in the data source as calendar entries',
      editor: 'switch',
      function: {
        name: 'getDynamicDataSources',
        params: ['app.id']
      },
      default: false,
      displayWhen: [
        {
          field: 'databindingDisabled',
          operator: '!==',
          value: true
        }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Set Selected Date from Selected Document',
      name: 'setSelectedDataFromDocument',
      description:
        'If true, will set the selected date on the calendar from the selected document in the data source based on the Data Binding Field',
      editor: 'switch',
      function: {
        name: 'getDynamicDataSources',
        params: ['app.id']
      },
      default: false,
      displayWhen: [
        {
          field: 'databindingDisabled',
          operator: '!==',
          value: true
        }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Date Selected Action',
      name: 'action',
      editor: 'dropdown',
      default: '',
      description: 'An action to run when a date is pressed',
      options: [],
      function: {
        name: 'getAppActions',
        params: ['app.id']
      },
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    'layout',
    {
      label: 'Publish Selected Date Keystore',
      name: 'publishToKeystore',
      description: 'If true, stores the selected date in the local store',
      editor: 'switch',
      default: false,
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Local Store Key',
      name: 'localStoreKey',
      description:
        'The key to store the selected date against in the local store. The key will be an object containing { day, dayname, month, monthname, week, year, date }',
      editor: 'textbox',
      default: 'selectedDate',
      displayWhen: [
        {
          field: 'publishToKeystore',
          operator: '=',
          value: true
        }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.BEHAVIOUR
    },
    {
      label: 'Text',
      name: 'text',
      editor: 'textbox',
      description: 'The text to use in t',
      default: 'Version #: ',
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Current Date Text Color',
      name: 'color',
      editor: 'color',
      description: 'The text color to use for todays date',
      default: 'red',
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      label: 'Current Date Background Color',
      name: 'backgroundColor',
      editor: 'color',
      description: 'The background color to use for todays date',
      default: 'red',
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      label: 'Selected Date Text Color',
      name: 'selectedDateColor',
      editor: 'color',
      description: 'The color for a selected date',
      default: '#000000',
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      label: 'Selected Date Background Color',
      name: 'selectedDateBackgroundColor',
      editor: 'color',
      description: 'The background color for a selected date',
      default: '#000000',
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      label: 'Entries Text Color',
      name: 'entriesColor',
      editor: 'color',
      description:
        'The text color of entries that are displayed in the calendar',
      default: '#000000',
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    {
      label: 'Entries Background Color',
      name: 'entriesBackgroundColor',
      editor: 'color',
      description:
        'The background color of entries that are displayed in the calendar',
      default: '#000000',
      group: ELEMENT_ATTRIBUTE_GROUP.COLORS
    },
    'font',
    'alignment',
    'margin',
    'padding'
  ]
};

export default CalendarElementFields;
